import { AxiosInstance, AxiosRequestConfig } from 'axios';

import { ResponseError } from './api';
const ENDPOINT = 'v2/token/';

export type SingInPayload = {
  username: string;
  password: string;
};

export const ACCESS_KEY = 'sneg_access';
export const REFRESH_KEY = 'sneg_refresh';

// eslint-disable-next-line import/no-anonymous-default-export
export default (instance: AxiosInstance, config: AxiosRequestConfig) => ({
  singIn: async (payload: SingInPayload) => {
    const response = await instance.post<ApiResponse<TokenResponse>>(ENDPOINT, payload, { ...config });
    if (response.data?.data?.access_token) {
      localStorage.setItem(ACCESS_KEY, response.data?.data?.access_token);
      localStorage.setItem(REFRESH_KEY, response.data?.data?.refresh_token);
      return response;
    } else {
      const err: ResponseError<TokenResponse> = new Error('Unauthorized');
      err.response = response;
      return Promise.reject(err);
    }
  },
  refresh: async () => {
    const token = localStorage.getItem(REFRESH_KEY);
    if (!token) {
      return Promise.reject(new Error('Unauthorized'));
    }
    const response = await instance.patch<ApiResponse<TokenResponse>>(ENDPOINT, {
      refresh_token: token
    }, { ...config });
    if (response.data?.data?.access_token) {
      localStorage.setItem(ACCESS_KEY, response.data.data.access_token);
      localStorage.setItem(REFRESH_KEY, response.data.data.refresh_token);
    } else {
      console.log('refresh error');
      const err: ResponseError<TokenResponse> = new Error('Unauthorized');
      console.log('refresh error', err);
      localStorage.removeItem(ACCESS_KEY);
      localStorage.removeItem(REFRESH_KEY);
      err.response = response;
      return Promise.reject(err);
    }
  },
  singOut: () => {
    console.log('sign out');
    localStorage.removeItem(ACCESS_KEY);
    localStorage.removeItem(REFRESH_KEY);
    location.reload();
    return Promise.resolve();
  },
});
